import { Button, Spin } from "antd";
import React, { Component } from "react";
import { FaPen } from "react-icons/fa";
import { connect } from "react-redux";
import { GetRequestDetailsAction } from "../../redux/order/order.action";
import PropertyDetails from "../PropertyDetails/PropertyDetails";
import CarModal from "../CarModal/CarModal";

class ClientProperty extends Component {
  state = {
    showAdd: false,
    userData: this.props.userData,
    detailsModal: false,
  };
  setDetailsModal = (value) => {
    this.setState({ detailsModal: value });
  };
  render() {
    const { userData, detailsModal } = this.state;
    console.log(userData, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
    return (
      <div className="client-info-wrapper">
        <header className="client-header">
          <h2 className="header-title">بيانات السياره</h2>
          {/* {!this.state.showAdd &&
            userData?.RealestateFinancingRequest == null && (
              <div className="header-btn-holder">
                <Button
                  type="primary"
                  size="large"
                  ghost
                  className="blue-btn"
                  onClick={() => this.setState({ showAdd: true })}
                  icon={<FaPen />}
                >
                  تعديل
                </Button>
              </div>
            )} */}
        </header>
        <div className="info-grid">
          <div className="info-grid-cell">
            <p className="info-cell-p">براند السياره</p>
            <h6 className="info-cell-val">
              {userData?.CarModel?.CarBrand?.NameLT}
            </h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">ماركه السياره</p>
            <h6 className="info-cell-val">{userData?.CarModel?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p">اللون المفضل</p>
            <h6 className="info-cell-val">{userData?.CarColor?.NameLT}</h6>
          </div>
          <div className="info-grid-cell">
            <p className="info-cell-p"> </p>
            <h6 className="info-cell-val">
              <Button
                type="primary"
                size="large"
                onClick={() => {
                  this.setState({ detailsModal: true });
                }}
              >
                اظهار بيانات السياره
              </Button>
            </h6>
          </div>
        </div>
        <CarModal
          mainData={userData?.CarModel}
          open={detailsModal}
          setOpen={() => this.setDetailsModal()}
          hideBtn
        />
        {/* {this.state.showAdd ? (
          <PropertyDetails
            userData={userData}
            handelShowInfo={this.handelShowInfo}
            editMode={true}
            showAdd={this.state.showAdd}
          />
        ) : this.props.RequestDetails != null ? (
          <>
            <div className="info-grid">
              <div className="info-grid-cell">
                <p className="info-cell-p">براند السياره</p>
                <h6 className="info-cell-val">
                  {userData?.CarFinancingRequest?.CarModel?.CarBrand?.NameLT}
                </h6>
              </div>
              <div className="info-grid-cell">
                <p className="info-cell-p">ماركه السياره</p>
                <h6 className="info-cell-val">
                  {userData?.CarFinancingRequest?.CarModel?.NameLT}
                </h6>
              </div>
              <div className="info-grid-cell">
                <p className="info-cell-p">اللون المفضل</p>
                <h6 className="info-cell-val">
                  {userData?.CarFinancingRequest?.CarColor?.NameLT}
                </h6>
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Spin size="large" />
          </div>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  FinanceRequestSources: state.user.metaData.FinanceRequestSources,
  ServiceTypes: state.user.metaData.ServiceTypes,
  RequestDetails: state.order.RequestDetails,
});
const mapDispatchToProps = (dispatch) => ({
  GetRequestDetailsAction: (data) => dispatch(GetRequestDetailsAction(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ClientProperty);
